module.exports = __webpack_public_path__ + "img/DX-black_.0d14a780.svg";